import React from 'react';
import styled from '@emotion/styled';
import { H4 } from '../Typography';
import CardButton from './CardButton';

const CardContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: 1px solid #dfe3e8;
`;

const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 8px;
`;

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

interface CardProps {
  ariaLabel?: string;
  headerText?: string;
  btnText?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  className?: string;
  testId?: string;
  showButton?: boolean;
  disableButton?: boolean;
}

const Card = ({
  ariaLabel = '',
  headerText,
  btnText,
  children,
  onClick,
  className,
  testId,
  showButton = true,
  disableButton = false,
}: CardProps): React.ReactElement => (
  <CardContainer className={`bundle-card ${className}`} data-testid={testId}>
    <CardHeader className="bundle-card__header">
      {headerText && (
        <H4 className="bundle-card__title" modifiers={{ bold: true }}>
          {headerText}
        </H4>
      )}
      {btnText && showButton && (
        <CardButton
          aria-label={ariaLabel}
          disabled={disableButton}
          onClick={onClick}
        >
          {btnText}
        </CardButton>
      )}
    </CardHeader>
    <CardBody className="bundle-card__body">{children}</CardBody>
  </CardContainer>
);

export default Card;
